import { render, staticRenderFns } from "./OurNumbers.vue?vue&type=template&id=1a0d20ce&scoped=true&"
import script from "./OurNumbers.vue?vue&type=script&lang=js&"
export * from "./OurNumbers.vue?vue&type=script&lang=js&"
import style0 from "./OurNumbers.vue?vue&type=style&index=0&id=1a0d20ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d20ce",
  null
  
)

export default component.exports